<template>
  <div>
    Login page
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      // some data
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/singIn/Login/Login.vue